import type { CustomerAuthPayload } from 'TYPES/api.body';

export const isOtpRequired = (payload: { otp_required?: boolean } | undefined | null): boolean =>
  payload?.otp_required === true;

export const isAccountNotVerifiedLoginError = (error: unknown): boolean => {
  if (typeof error !== 'object' || error === null || !('response' in error)) return false;
  const response = (error as { response?: { status?: number; data?: { message?: string; description?: string } } })
    .response;
  const message = response?.data?.message ?? response?.data?.description ?? '';
  return response?.status === 403 && /account not verified/i.test(message);
};

export const persistCustomerAuth = (data: CustomerAuthPayload) => {
  localStorage.setItem('access_token', data.access_token);
  localStorage.setItem('is_login', 'true');
  if (data.user) {
    localStorage.setItem('user', JSON.stringify(data.user));
  }
};

export const resolvePostAuthPath = (options?: { reroute?: string | null; redirect?: string | null }): string => {
  const savedReturnUrl = localStorage.getItem('return_url');
  if (savedReturnUrl && savedReturnUrl !== '/login') {
    localStorage.removeItem('return_url');
    return savedReturnUrl;
  }
  if (options?.redirect && options.redirect !== '/login') {
    return decodeURIComponent(options.redirect);
  }
  if (options?.reroute != null && options.reroute !== '') {
    return `${options.reroute}?refresh=True`;
  }
  return '/';
};
